import { render, staticRenderFns } from "./Pannel.vue?vue&type=template&id=54f39c5f&"
import script from "./Pannel.vue?vue&type=script&lang=js&"
export * from "./Pannel.vue?vue&type=script&lang=js&"
import style0 from "./Pannel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports